export default __webpack_public_path__ + "static/media/mock-data.png.webp";